import { AppModule } from '@app/app.module';
import { OrderDirection, TableFilter, TableHeader, TableInputFilter, TableSelectFilter } from '@beego/ngx-table';
import { EventTypeProvider } from '@internal-providers/event-type.provider';
import { WaitListItemStatus } from '@shared-libs/enums';
import { translate } from '@shared-libs/helpers';

export class WaitListTableFactory {
	public static getHeaders(): Array<TableHeader> {
		return [
			new TableHeader(translate('WAIT_LIST.CREATED_AT'), ['createdAt', OrderDirection.asc], 2),
			new TableHeader(translate('WAIT_LIST.STATUS_LABEL'), ['status', OrderDirection.asc], 2),
			new TableHeader(translate('WAIT_LIST.TYPE_LABEL'), ['type', OrderDirection.asc], 3),
			new TableHeader(translate('WAIT_LIST.DESCRIPTION'), null, 2),
			new TableHeader(translate('WAIT_LIST.CLIENT'), null, 3),
			new TableHeader(translate('WAIT_LIST.CREATED_BY'), null, 2),
			new TableHeader(),
		];
	}

	public static getFilters(): { [key: string]: TableFilter } {
		const eventTypeProvider: EventTypeProvider = AppModule.injector.get(EventTypeProvider);

		return {
			typeFilter: new TableSelectFilter({
				property: 'type',
				name: translate('FILTERS.WAIT_LIST_ITEM_TYPE.TITLE'),
				data: async () =>
					(await eventTypeProvider.getAll()).map((eventType) => ({
						name: eventType.name,
						value: eventType.name,
					})),
				resource: 'online',
				placeholder: translate('FILTERS.WAIT_LIST_ITEM_TYPE.PLACEHOLDER'),
			}),
			statusFilter: new TableSelectFilter({
				property: 'status',
				name: translate('FILTERS.WAIT_LIST_ITEM_STATUS.TITLE'),
				data: Object.keys(WaitListItemStatus).map((key) => ({
					value: WaitListItemStatus[key],
					name: translate(`WAIT_LIST.STATUS.${key.toUpperCase()}`),
				})),
				resource: 'local',
				placeholder: translate('FILTERS.WAIT_LIST_ITEM_STATUS.PLACEHOLDER'),
				default: [WaitListItemStatus.Requested],
			}),
			descriptionFilter: new TableInputFilter({
				property: 'description',
				name: translate('FILTERS.WAIT_LIST_ITEM_DESCRIPTION.TITLE'),
				placeholder: translate('FILTERS.WAIT_LIST_ITEM_DESCRIPTION.PLACEHOLDER'),
			}),
			clientNameFilter: new TableInputFilter({
				property: 'Client.name',
				name: translate('FILTERS.WAIT_LIST_ITEM_NAME.TITLE'),
				placeholder: translate('FILTERS.WAIT_LIST_ITEM_NAME.PLACEHOLDER'),
			}),
			emailFilter: new TableInputFilter({
				property: 'Client.email',
				name: translate('FILTERS.WAIT_LIST_ITEM_EMAIL.TITLE'),
				placeholder: translate('FILTERS.WAIT_LIST_ITEM_EMAIL.PLACEHOLDER'),
			}),
			phoneFilter: new TableInputFilter({
				property: 'Client.phone',
				name: translate('FILTERS.WAIT_LIST_ITEM_PHONE.TITLE'),
				placeholder: translate('FILTERS.WAIT_LIST_ITEM_PHONE.PLACEHOLDER'),
			}),
		};
	}
}
